import React from "react";
import classNames from "classnames";
import { Button } from "../Button/Button";
import { ArrowDownIcon, ArrowUpIcon } from "../../../icons";
import { useInteraction } from "../../../hooks/useInteraction";
import { ButtonProps } from "../Button/ButtonCore";
import styles from "./Collapsible.module.scss";

interface Props {
    isOpened: boolean;
    onToggle: () => void;
    children?: React.ReactNode;
    actions?: React.ReactNode;
    enabled?: boolean;
    className?: string;
    collapseButtonSize?: ButtonProps["size"];
}

export const CollapsibleHeader: React.FC<Props> = ({
    isOpened,
    onToggle,
    children,
    actions,
    enabled = true,
    className,
    collapseButtonSize,
}) => {
    const click = useInteraction(onToggle);

    return (
        <header
            className={classNames(
                "collapsible__header",
                styles.collapsibleHeader,
                isOpened && styles.opened,
                className,
            )}
            {...click}
        >
            <div className="collapsible__header__content">{children}</div>

            <aside
                className={classNames(
                    "collapsible__header__actions",
                    styles.actions,
                )}
            >
                {actions}
                {enabled && (
                    <Button variant="tertiary" icon size={collapseButtonSize}>
                        {isOpened ? <ArrowUpIcon /> : <ArrowDownIcon />}
                    </Button>
                )}
            </aside>
        </header>
    );
};
